import React from 'react'

import CoverArtPreviewHandle from '@components/myScores/ScoresView/ScoreGridView/CoverArtHandle/CoverArtPreviewHandle'
import Product from '@models/Product'
import Score from '@models/Score'

import CoverArtEditableHandle from './CoverArtEditableHandle'

interface Props {
  score: Score | Product
  /** Whether items in the score list can have actions performed on them */
  editable?: boolean
}

const CoverArtHandle: React.FC<Props> = ({ score, editable }: Props) => {
  return (
    <div className="relative min-w-[75px] w-[75px] h-[75px] overflow-hidden group">
      {editable ? (
        <CoverArtEditableHandle score={score} />
      ) : (
        <CoverArtPreviewHandle score={score} />
      )}
    </div>
  )
}

export default CoverArtHandle
